import React, { useState } from "react";

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqs = Array(8).fill({
    question: "Since how long has JSV been in the construction business?",
    answer:
      "JSV has been operating in the construction industry for several years, delivering quality projects with experienced professionals and modern techniques.",
  });

  return (
    <div className="max-w-[1100px] mx-auto grid grid-cols-1 md:grid-cols-2 gap-5">
      {faqs.map((faq, i) => (
        <div key={i} className="border-b border-gray-300 py-3">
          
          {/* QUESTION */}
          <div
            onClick={() => toggleFAQ(i)}
            className="flex justify-between items-center cursor-pointer text-sm"
          >
            <p>{faq.question}</p>
            <span className="text-lg font-bold">
              {openIndex === i ? "−" : "+"}
            </span>
          </div>

          {/* ANSWER */}
          <div
            className={`overflow-hidden transition-all duration-300 text-xs text-gray-600 mt-2 ${
              openIndex === i ? "max-h-40 opacity-100" : "max-h-0 opacity-0"
            }`}
          >
            {faq.answer}
          </div>
        </div>
      ))}
    </div>
  );
};

export default FAQSection;